import { P2RegularLink as P2RegularLinkStyle } from 'theme/typography';
import { Text, TextProps } from '@mantine/core';
import mergeTextSx from 'components/typography/merge-text-sx';

/**
 * Applies the P2RegularLink typography style.
 */
export default function P2RegularLink({ sx, ...props }: TextProps) {
  return <Text {...props} sx={mergeTextSx(P2RegularLinkStyle, sx)} />;
}
